import { useState } from 'react';
import { useTranslation } from 'react-i18next';
// Components
import Collapse from '@mui/material/Collapse';
import { TransitionGroup } from 'react-transition-group';
import CircularProgress from '@mui/material/CircularProgress';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';

// Styles
import styles from './index.module.sass';
import { styled } from '@mui/material/styles';

const date = new Date();

const CustomWidthTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} enterTouchDelay={0} />
))({
  [`& .${tooltipClasses.arrow}`]: {
    color: '#002747',
  },
  [`& .${tooltipClasses.tooltip}`]: {
    maxWidth: 100,
    backgroundColor: '#002747',
  },
});

function renderItem({
  imagen,
  descri,
  clave,
  cantidad,
  letra,
  precio,
  importe,
  status,
  onQuantityChange,
  screenSize,
  loading,
  agrupador,
  t,
}) {
  return (
    <div className={`${styles.container} ${styles[screenSize]}`}>
      <div className={styles.image}>
        <img src={`${imagen}?x=${date.getFullYear()}${date.getMonth() + 1}`} alt={descri} />
      </div>
      <div className={styles.mobil}>
        <div className={styles.itemName}>
          <div className={styles.name}>
            <label className={styles.idname}>
              <label className={styles.id}>{clave}</label> -{' '}
              <label className={styles.descri}>{descri}</label>
              {agrupador === 'COMPONENTES' && (
                <label className={styles.descri}> ({t('isComponent')})</label>
              )}
              {agrupador === 'REGALOS' && <label className={styles.descri}> ({t('isGift')})</label>}
              {agrupador === 'TAX' && <label className={styles.descri}> ({t('isTax')})</label>}
            </label>
          </div>
        </div>
        <div className={styles.totals}>
          <div className={`${styles.column}`}>
            {t('tableRowUni')} <br />
            {cantidad}
          </div>
          <div className={`${styles.column}`}>
            {t('tableRowLetter')} <br />
            {letra}
          </div>
          <div className={`${styles.column}`}>
            {t('tableRowPrice')} <br />${precio}
          </div>
          <div className={`${styles.column}`}>
            {t('tableRowAmount')} <br />${importe}
          </div>
        </div>

        <div className={styles.actions}>
          {((status === 'Producto Agotado.' || status === 'Product Sold Out.') && (
            <div className={`${styles.soldout}`}>
              <label>{t('defaultSoldOut')}</label>
            </div>
          )) ||
            (agrupador !== 'COMPONENTES' && agrupador !== 'REGALOS' && agrupador !== 'TAX' && (
              <div className={`${styles.actionsIcons} ${cantidad < 2 && styles.flexEnd}`}>
                {(loading && (
                  <div className={styles.circularContainer}>
                    <CircularProgress className={styles.circularAction} />
                  </div>
                )) || (
                  <>
                    {cantidad > 1 && (
                      <i
                        className={`material-icons ${styles.icon}`}
                        onClick={() => onQuantityChange('less')}>
                        remove
                      </i>
                    )}
                    {/* <label>1</label> */}
                    <i
                      className={`material-icons ${styles.icon}`}
                      onClick={() => onQuantityChange('add')}>
                      add
                    </i>
                  </>
                )}
              </div>
            ))}

          {status !== '' && (
            <div className={styles.alert}>
              <CustomWidthTooltip title={status} placement='right' arrow>
                {
                  <span className={`material-icons-outlined ${styles.tooltip}`}>
                    report_problem
                  </span>
                }
              </CustomWidthTooltip>
            </div>
          )}

          {agrupador !== 'COMPONENTES' && agrupador !== 'REGALOS' && agrupador !== 'TAX' && (
            <div className={`${styles.actionsDelete}`}>
              {(loading && <CircularProgress className={styles.circularDelete} />) || (
                <i
                  className={`material-icons-outlined ${styles.icon}`}
                  onClick={() => onQuantityChange('delete')}>
                  delete
                </i>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

//BORRARPRO
export default function TableRowMobil({ node, getOrder, device }) {
  const {
    imagen = '',
    clave = '',
    descri = '',
    cantidad = '',
    letra = '',
    precio = '',
    importe = '',
    status = '',
    categoria = '',
    numeroLinea = '',
    agrupador = '',
  } = node;

  const [loading, setloading] = useState(false);

  const screenSize = device?.screenSize || 'desktop';
  const { t } = useTranslation('order');

  async function onQuantityChange(action) {
    setloading(true);
    let result;
    if (action === 'add')
      result = await getOrder(
        'ORDENARTAX',
        categoria,
        clave,
        parseInt(cantidad) + 1,
        numeroLinea,
        false,
      );
    else if (action === 'delete') {
      result = await getOrder(
        'BORRARPRO',
        categoria,
        clave,
        parseInt(cantidad),
        numeroLinea,
        false,
      );
      console.log(result);
    } else {
      if (parseInt(cantidad) <= 1) return;
      else
        result = await getOrder(
          'ORDENARTAX',
          categoria,
          clave,
          parseInt(cantidad) - 1,
          numeroLinea,
          false,
        );
    }
    setloading(false);
  }
  return (
    <div>
      <TransitionGroup>
        <Collapse key={clave} timeout={500}>
          {renderItem({
            imagen,
            descri,
            clave,
            cantidad,
            letra,
            precio,
            importe,
            status,
            onQuantityChange,
            screenSize,
            loading,
            agrupador,
            t,
          })}
        </Collapse>
      </TransitionGroup>
    </div>
  );
}
